"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIFrame = exports.onIframeMessage = void 0;
var onIframeMessage = function (event, callbacks, iFrameUrl) {
    var messageOrigin = event.iframe.src.replace(/\/$/, ''); // remove trailing slash from src
    if (messageOrigin === iFrameUrl) {
        var message = event.message;
        switch (message.type) {
            case 'NOTIFICATION_COUNT':
                callbacks['notificationCount'](message.payload.count);
                break;
            case 'MAX_NOTIFICATION_PRIORITY':
                callbacks['notificationPriority'](message.payload.importance);
                break;
            default:
                break;
        }
    }
};
exports.onIframeMessage = onIframeMessage;
var isIFrame = function (input) {
    return input !== null && input.tagName === 'IFRAME';
};
exports.isIFrame = isIFrame;
